import { $$ } from '../utils/dom';
import { ClickRedirect } from '../modules/click-redirect';

const clickRedirectInstances = [];
const clickRedirects = $$('[data-click-redirect]');

clickRedirects.forEach(clickRedirect => {
  const config = JSON.parse(
    clickRedirect.dataset.clickRedirect.replaceAll("'", '"')
  );
  const clickRedirectInstance = new ClickRedirect(clickRedirect, config);
  clickRedirectInstances.push(clickRedirectInstance);
  clickRedirectInstance.activate();
});
